import React, { useState } from 'react'
import { ISellerTableProductItem } from '../../../../../modules/API/Seller/models/tableData'
import { ISizeItem } from '../../../../../modules/API/Products/models/size'
import ImageComponentHead from '../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../generic/assets/cogsPNG.png'
import { FormShell, FormField, FormFooter } from '../../../../../generic/ui/FormLayout'
import SizeSelector from '../../../../../generic/ui/Selectors/SizeSelector'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import { useTranslation } from 'react-i18next'

interface Props {
  item: ISellerTableProductItem,
  handleSave: (sizeID: string, isChange?: boolean) => void,
  sizeList: ISizeItem[],
  isEdit: boolean
}

const SelectSizeModal = ({
  item,
  handleSave,
  sizeList,
  isEdit
}: Props) => {
  const [t] = useTranslation('buttons')
  const defaultSize = sizeList.find(size => size.Description === item.Product.SizeID) || null
  const [selectedSize, setSelectedSize] = useState<ISizeItem | null>(isEdit ? defaultSize : null)
  const handleSaveItem = () => {
    if(!selectedSize) return
    handleSave(selectedSize?.Description || '')
  }
  return (
    <FormShell>
      <ImageComponentHead img={Image} />
      <FormField label='בחר גודל'>
        <SizeSelector
          sizes={sizeList}
          value={selectedSize}
          onSelect={setSelectedSize}
        />
      </FormField>
      <FormFooter>
        <AccentButton
          type='button'
          onClick={handleSaveItem}
          disabled={!selectedSize}
          fullWidth={false}
        >
          {t('save')}
        </AccentButton>
      </FormFooter>
    </FormShell>
  )
}

export default SelectSizeModal
